import React, { useState, useEffect } from "react";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import EffectCarousel from "@/components/Carousel/effect-carousel.esm";
import { PreviewCloudinaryImage } from "@/features/previews/shared/components/PreviewCloudinaryImage";
import { Lightbox } from "@/components/Lightbox";
import { Image } from "@/types/types";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/virtual";
import "@/components/Carousel/effect-carousel.scss";
import "@/components/Carousel/styles.scss";

interface GalleryContainerProps {
  images: any[];
  expandable?: boolean;
  isInitPreview?: boolean;
}

const emptyImage = {
  url: "",
  alt: "",
} as Image;

const initialLightboxState = {
  open: false,
  image: emptyImage,
};

export const GalleryContainer = ({
  images,
  expandable = true,
  isInitPreview = false,
}: GalleryContainerProps) => {
  const [lightboxState, setLightboxState] = useState(initialLightboxState);

  useEffect(() => {
    if (images && images.length > 0) {
      new Swiper(".swiper", {
        modules: [Navigation, EffectCarousel],
        effect: "carousel",
        grabCursor: true,
        loop: true,
        slidesPerView: "auto",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          delay: 3000,
        },
      });
    }
  }, [images]);

  const onImageClick = (src: string, alt: string) => {
    if (expandable && !isInitPreview) {
      setLightboxState((prev) => ({
        ...prev,
        open: true,
        image: {
          url: src,
          alt,
        },
      }));
    }
  };

  const onCloseLightbox = () => {
    setLightboxState((prev) => ({
      ...prev,
      open: false,
      image: emptyImage,
    }));
  };

  if (!images || images.length === 0) return null;

  return (
    <React.Fragment>
      <div
        data-testid="GalleryContainer"
        className="swiper"
      >
        <div className="swiper-wrapper">
          {images.map((image, imageIdx) => (
            <div
              className="swiper-slide"
              key={imageIdx}
            >
              <div
                className="swiper-carousel-animate-opacity"
                onClick={() => onImageClick(image.url, `gallery image ${imageIdx + 1}`)}
              >
                <PreviewCloudinaryImage
                  src={image.url}
                  alt={`gallery image ${imageIdx + 1}`}
                  className="images-preview__carousel-image"
                  variant="gallery"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <Lightbox
        open={lightboxState.open}
        image={lightboxState.image}
        onClose={onCloseLightbox}
      />
    </React.Fragment>
  );
};
